export enum ShelfTalkerCardSize {
  ShelfTalkerSize_PostCard = 'ShelfTalkerSize_PostCard',
  ShelfTalkerSize_Custom5x7 = 'ShelfTalkerSize_Custom5x7'
}
